import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'

import Pagination from './Pagination'
import Sort from './Sort'

const ProjectList = ({ list, listProjects, query, order, handleSubmit, submitting, reset }) => {
  React.componentDidMount = function() {
    document.title = "Project List";
  }

  if (!list) return (<div/>)
  const { limit, page, count, rows } = list
  const projectRows = rows.map(row => (
    <tr key={row.id}>
      <td><span className="tx-14 tx-bold">{row.name}</span>
      <p className="tx-13 tx-gray-700 hidden-lg-down">{row.description}</p>
      </td>
      {/*<td><span className="tx-12"></span></td>*/}
      <td className="text-right"><span className="tx-14">{row.defectSummary.total}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.open}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.accept}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.inprogress}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.done}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.reopen}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.close}</span></td>
      <td className="text-right text-danger"><span className="tx-14">{row.defectSummary.delayed}</span></td>
      <td className="text-right"><span className="tx-14">{row.defectSummary.my}</span></td>
      <td className="text-center">
        <Link title="รายละเอียดโครงการ" className="btn-icon-custom tx-center mg-r-5 mg-sm-b-10 mg-lg-b-0" to={`/project/${row.id}/details`}>
          <i className="icon ion-clipboard tx-primary tx-20"></i>
        </Link>
        <Link title="แก้ไขโครงการ" className="btn-icon tx-center mg-sm-b-10 mg-lg-b-0" to={`/project/${row.id}/edit`}>
          <i className="icon ion-gear-b tx-primary tx-20"></i>
        </Link>
      </td>
    </tr>
  ))
  const pagination = count !== 0 ?
    <Pagination limit={limit} page={page} count={count} query={query} onPageClick={listProjects}/> : undefined
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <div className="float-right float-btn">
          <Link to={'/project/add'} className="btn btn-primary">สร้างโครงการ</Link>
        </div>
        <h4 className="tx-gray-800 mg-b-5">โครงการ</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <div>
            <div className="form-layout form-layout-2">
              <form className="row no-gutters" onSubmit={handleSubmit((values) => {listProjects(values)})}>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="name" className="form-control-label">ชื่อโครงการ :</label>
                    <Field name="name" component="input" type="text" placeholder="ชื่อโครงการ" className="form-control"/>
                  </div>
                </div>
                <div className="col-lg-3 mg-t--1 mg-md-t-0">
                  <div className="form-group mg-md-l--1">
                    <label htmlFor="description" className="form-control-label">รายละเอียด :</label>
                    <Field name="description" component="input" type="text" placeholder="รายละเอียด"
                           className="form-control"/>
                  </div>
                </div>
                <div className="col-lg-3 mg-t--1 mg-md-t-0">
                  <div className="form-group mg-md-l--1">
                    <label htmlFor="collaboratorName" className="form-control-label">ผู้เกี่ยวข้อง :</label>
                    <Field name="collaboratorName" component="input" type="text" placeholder="ผู้เกี่ยวข้อง"
                           className="form-control"/>
                  </div>
                </div>
                <div className="col-lg-3 mg-t--1 mg-md-t-0">
                  <div className="form-group mg-md-l--1">
                    <label htmlFor="adminCollaboratorName" className="form-control-label">ผู้รับผิดชอบหลัก :</label>
                    <Field name="adminCollaboratorName" component="input" type="text" placeholder="ผู้รับผิดชอบหลัก"
                           className="form-control"/>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-layout-footer bd pd-20 bd-t-0">
                    <button type="submit" className="btn btn-primary mg-r-10" disabled={submitting}>ค้นหา</button>
                    <button type="button" className="btn btn-outline-primary" disabled={submitting} onClick={() => {
                      reset()
                      listProjects()
                    }}>ยกเลิก
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <br/>
            <div className="">
              <div className="table-responsive mg-b-20">
                <table className="table table-bordered table-colored table-dark">
                  <thead className="thread-light thead-colored thead-primary">
                  <tr>
                    <th className="text-center" scope="col" onClick={() => listProjects(query, 'name')}>
                      <span className="tx-13">ชื่อโครงการ</span> <Sort name="name" order={order}/>
                    </th>
                    {/*<th className="wd-lg-350" scope="col" onClick={() => listProjects(query, 'description')}>*/}
                      {/*<span className="tx-13">Description</span> <Sort name="description" order={order}/>*/}
                    {/*</th>*/}
                    <th className="text-center wd-lg-5p wd-md-90" scope="col"><span className="tx-13">จำนวนงานทั้งหมด</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">เปิด</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">รับเรื่องแล้ว</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">กำลังปรับปรุง</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">ปรับปรุงแล้ว</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">เปิดใหม่</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">ปิด</span></th>
                    <th className="text-center wd-lg-5p wd-md-60 text-danger" scope="col"><span className="tx-13">งานที่เกินกำหนด</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">งานที่รับผิดชอบ</span></th>
                    <th className="text-center wd-lg-5p wd-md-60" scope="col"><span className="tx-13">Action</span></th>
                  </tr>
                  </thead>
                  <tbody>
                  {projectRows}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mg-b-20">
                <div className="row align-items-right justify-content-center">
                  {pagination}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default reduxForm({
  form: 'project-list'
})(ProjectList)



// WEBPACK FOOTER //
// ./src/components/ProjectList.js